/**
 * D-321 - the "עבודה פנימית OTE" hub: same tab row as a customer card, but only what has no money and no
 * portal in it. Pure (no React) so the rule is testable.
 */
export const INTERNAL_HUB_PATH = '/internal-work';

export const INTERNAL_HUB_TABS = ['overview', 'projects', 'tasks', 'hours', 'documents', 'meetings'] as const;
export type InternalHubTab = (typeof INTERNAL_HUB_TABS)[number];

/** Tabs that always sit in the row; the rest are behind "עוד" so the row never overflows a 390px phone. */
export const INTERNAL_HUB_PRIMARY_TABS: readonly InternalHubTab[] = ['overview', 'projects', 'tasks', 'hours'];

/** Tabs a customer card has that the internal hub must NEVER show (D-321 sec.3). */
export const INTERNAL_HUB_FORBIDDEN_TABS = [
  'billing', 'profitability', 'contracts', 'quotes', 'contacts', 'hour-banks',
  'service-contracts', 'lll', 'developments', 'service-requests', 'portal', 'sla',
] as const;

export function isInternalHubTab(v: string | null | undefined): v is InternalHubTab {
  return !!v && (INTERNAL_HUB_TABS as readonly string[]).includes(v);
}

/** The open tab from `?tab=`; anything unknown (or a forbidden customer tab) falls back to the overview. */
export function internalHubActiveTab(param: string | null | undefined): InternalHubTab {
  return isInternalHubTab(param) ? param : 'overview';
}

/** Whole minutes as H:MM (the hub shows hours the way the logs do). */
export function hubClock(minutes: number): string {
  const m = Math.max(0, Math.round(minutes || 0));
  return `${Math.floor(m / 60)}:${String(m % 60).padStart(2, '0')}`;
}
